var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1c40f",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(8.53333,8.53333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,3c-0.83157,0 -1.54394,0.50672 -1.8457,1.22852l-10.85352,18.71875v0.00195c-0.19588,0.31554 -0.30003,0.67939 -0.30078,1.05078c0,1.10457 0.89543,2 2,2c0.04693,-0.0003 0.09383,-0.00226 0.14063,-0.00586l0.00391,0.00586h10.85547h10.85547l0.00391,-0.00781c0.04677,0.00425 0.09367,0.00686 0.14063,0.00781c1.10457,0 2,-0.89543 2,-2c-0.00039,-0.37206 -0.10455,-0.73663 -0.30078,-1.05273l-0.01562,-0.02734c-0.00065,-0.00065 -0.0013,-0.0013 -0.00195,-0.00195l-10.83594,-18.68945c-0.30177,-0.72179 -1.01413,-1.22852 -1.8457,-1.22852zM13.78711,11.35938h2.42578l-0.20117,6.47266h-2.02344zM15.00391,19.81055c0.822,0 1.31445,0.44227 1.31445,1.19727c0,0.741 -0.49245,1.18164 -1.31445,1.18164c-0.828,0 -1.32422,-0.44064 -1.32422,-1.18164c0,-0.755 0.49522,-1.19727 1.32422,-1.19727z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning2);
export default __webpack_public_path__ + "static/media/warning2.2771131b3845c83cd948525f3de3a9fc.svg";
export { ForwardRef as ReactComponent };